// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2lU-1","sendOtp":"AuthorizeToLogin_sendOtp__1zFLQ"};